export interface ISoccerJ1LeagueState {
  isShow: boolean;
  games?: Array<{
    url: string;
    teamHome: string;
    teamVisitor: string;
  }>;
}
const initialState: ISoccerJ1LeagueState = {
  isShow: false
};
export default (state: ISoccerJ1LeagueState = initialState) => {
  return state;
};
